import { Application } from "../shared";

window.onload = function () {
    const app = new Application();
};
